export default __webpack_public_path__ + "static/MastheadAnimations-abff6b9a5f34a8f43d3cdfc56a38dff1.png";